import { Pipe, PipeTransform } from '@angular/core';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';

@Pipe({
    name: 'isNilOrEmpty',
})
export class IsNilOrEmptyPipe implements PipeTransform {
    transform(value: unknown): boolean {
        return isNilOrEmpty(value);
    }
}
